import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_ASSOCIATION_DEFINITIONS } from 'flow-doctor-lib/queries/AssociationQueries';
const useObjectTypeIdFromAssociation = ({
  portalId,
  associationTypeId,
  associationCategory
}) => {
  const {
    error,
    loading,
    data
  } = useQuery(GET_ASSOCIATION_DEFINITIONS, {
    variables: {
      portalId
    }
  });
  const matchingObjectTypeId = useMemo(() => {
    if (data) {
      // Results are returned non-deterministically between ids and inverse ids
      const matchingDef = data.flowDoctor_associationDefinitions.find(def => (def.id === associationTypeId || def.inverseId === associationTypeId) && def.category === associationCategory);
      return matchingDef ? matchingDef.id === associationTypeId ? matchingDef.toObjectTypeId : matchingDef.fromObjectTypeId : null;
    }
    return null;
  }, [data, associationTypeId, associationCategory]);
  return {
    objectTypeId: matchingObjectTypeId,
    loading,
    error
  };
};
export default useObjectTypeIdFromAssociation;